<div fxLayout="row">

    <div fxFlex="40" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="20px">
        <mat-icon svgIcon="arrow-below"></mat-icon>
        <span>{{"PRODUCT" | translate}}</span>
    </div>
    <div fxFlex="30" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="20px">
        <mat-icon svgIcon="arrow-below"></mat-icon>
        <span>{{"QUANTITY" | translate}}</span>
    </div>
    <div fxFlex="30" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="20px">
        <mat-icon svgIcon="arrow-below"></mat-icon>
        <span>{{"TOTAL_PRICE" | translate}}</span>
    </div>
</div>
